const backendUrl = process.env.REACT_APP_BACKEND_DOMAIN;
import { createContext } from "react";
import socketIO from "socket.io-client";

const SOCKET_URL = backendUrl;

export const socket = socketIO.connect(SOCKET_URL);
export const SocketContext = createContext();
